module.exports = __webpack_public_path__ + "img/days-switch.7f8b0598.png";